var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlip = function SvgFlip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169 911v-71h105l-5-5q-65-56-96.5-117.5T141 579q0-118 74.5-209.5T406 249v96q-76 23-123 88.5T236 579q0 59 22 102t60 75l24 15V666h71v245H169Zm386-7v-97q77-23 123-88.5T724 573q0-44-22.5-90T645 401l-23-20v105h-72V241h245v71H688l6 7q62 58 93.5 125T819 573q0 118-74 210T555 904Z"
  })));
};
export default SvgFlip;